import {css, Icon, Link, view} from '@sail/ui/deprecated';
import {document} from '@sail/icons/react/Icon';
import prettyBytes from 'pretty-bytes';
import {ChatRow} from './ChatRow';
import {ChatBubble} from './ChatBubble';
import {useTheme} from '../../ThemeProvider';
import {useNewUniversalHelpDesign} from '../../FeatureFlagsProvider';
import {AttachmentRowNext} from './AttachmentRowNext';

export type Props = {
  name: string;
  size: number;
  url?: string;
  position?: 'start' | 'end';
  avatar?: React.ReactNode | null | undefined;
  error?: React.ReactNode;
  ChatRowComponent?: React.ComponentType<React.ComponentProps<typeof ChatRow>>;
  ChatBubbleComponent?: React.ComponentType<
    React.ComponentProps<typeof ChatBubble>
  >;
};

const AttachmentInfoCurrent = ({
  name,
  size,
  ChatBubbleComponent,
}: {
  name: string;
  size: number;
  ChatBubbleComponent: React.ComponentType<
    React.ComponentProps<typeof ChatBubble>
  >;
}) => {
  const {brandColor} = useTheme();

  return (
    <ChatBubbleComponent
      background="neutral100"
      borderTop={`4px solid ${brandColor}`}
    >
      <view.div
        css={{
          display: css.value('flex'),
          flexDirection: css.value('row'),
          maxWidth: css.value('100%'),
        }}
      >
        <Icon
          icon={document}
          size="xsmall"
          css={{
            marginTop: css.value('4px'),
            marginRight: css.value('8px'),
            flexShrink: css.value('0'),
          }}
        />
        <view.div css={{overflow: 'hidden'}}>
          <view.p
            css={{
              font: 'body',
              marginY: css.value('0px'),
              overflow: 'hidden',
              textOverflow: css.value('ellipsis'),
              whiteSpace: css.value('nowrap'),
            }}
          >
            {name}
          </view.p>
          <view.p
            css={{
              font: 'caption',
              color: 'disabled',
              marginY: css.value('0px'),
            }}
          >
            {prettyBytes(size)}
          </view.p>
        </view.div>
      </view.div>
    </ChatBubbleComponent>
  );
};

export const AttachmentRow = ({
  name,
  size,
  position,
  avatar,
  error,
  url,
  ChatRowComponent = ChatRow,
  ChatBubbleComponent = ChatBubble,
}: Props) => {
  const useNewDesign = useNewUniversalHelpDesign();

  if (useNewDesign) {
    return (
      <AttachmentRowNext name={name} size={size} error={error} url={url} />
    );
  }

  return (
    <view.div data-testid="attachment-row">
      <ChatRowComponent avatar={avatar} position={position} error={error}>
        {url ? (
          <Link
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            type="secondary"
            css={{minWidth: 0}}
            data-testid="attachment-link"
          >
            <AttachmentInfoCurrent
              name={name}
              size={size}
              ChatBubbleComponent={ChatBubbleComponent}
            />
          </Link>
        ) : (
          <AttachmentInfoCurrent
            name={name}
            size={size}
            ChatBubbleComponent={ChatBubbleComponent}
          />
        )}
      </ChatRowComponent>
    </view.div>
  );
};
